<template>
  <div
    class="w-full max-w-192 h-screen relative overflow-hidden flex justify-center items-center flex-col"
  >
    <transition name="fadeUp">
      <div
        v-if="pageNumber === 2"
        class="bg-scenario-bg bg-no-repeat bg-cover w-812 h-781 xl:w-702 xl:h-671 lg:w-800 lg:h-4.8 flex justify-center items-center"
      >
        <p
          class="font-mulish-regular text-1.6 2xl:text-1.6 lg:text-1.2 text-center xl:px-40 lg:px-32 xl:pt-16 lg:pt-24"
        >
          Gaia, the Goddess of the Earth, summons the adventurer to Adrica to
          tell the power source for Iris is in northern Adrica.
          <br /><br />
          The adventurer steps on the newly revealed land in Eastland called
          "Phobos" with various suspicions. The grotesque land that is different
          from ordinary places where demons reside instead of life... It seems
          that the problems here will not be easy to solve.
          <br /><br />
          Rumors that Mayor Klaus is missing and the savage King Valdrick has
          opened the door to the demon world. And the appearance of a strange
          garden full of red roses that do not suit Phobos.
          <br /><br />
          The adventurer believes that this is not a coincidence, and decides to
          find the real story of "Phobos," which everyone was reluctant to do.
        </p>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapState } from 'vuex';
//import SectionTag from '../components/SectionTag';
export default {
  // components: {
  //   SectionTag,
  // },
  computed: {
    ...mapState({
      imgPath: state => state.AppConfig.imgPath,
      pageNumber: state => state.AppConfig.pageNumber,
    }),
  },
};
</script>
